var amdi18n={"__root":{"ADD_MUTE_WRAP_MENU_LABEL":"Mute selection","MUTE_WRAP_BRACKET_LABEL":"Muted","REMOVE_MUTE_WRAP":"Remove mute","MUTE_WRAP_TOOLTIP":"Silences this section without cutting it"},"__fr":{"ADD_MUTE_WRAP_MENU_LABEL":"Couper le son de la sélection","MUTE_WRAP_BRACKET_LABEL":"Muet","REMOVE_MUTE_WRAP":"Réactiver le son","MUTE_WRAP_TOOLTIP":"Coupe le son de cette section sans la supprimer"},"__en":{"ADD_MUTE_WRAP_MENU_LABEL":"Mute selection","MUTE_WRAP_BRACKET_LABEL":"Muted","REMOVE_MUTE_WRAP":"Remove mute","MUTE_WRAP_TOOLTIP":"Silences this section without cutting it"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;